import { BaseServiceDefinition } from './BaseService';
import { PointOfInterest } from '@/models/pointOfInterest';

class PointsOfInterestService extends BaseServiceDefinition {
  constructor() {
    super();
  }

  public getPointsOfInterest(): Promise<PointOfInterest[]> {
    return this.get('/api/v1/pointsOfInterest')
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return Promise.reject(error);
      });
  }
}

const pointsOfInterestService: PointsOfInterestService =
  new PointsOfInterestService();

export default pointsOfInterestService;
